import { useState } from 'react'
import { InView } from 'react-intersection-observer'

/**
 * Hide content on the server-side-render. Show the content when the user scrolls into the section.
 */
export const HideContentFromServerRender = ({
  children,
  hideContent = true,
}: {
  children: React.ReactNode
  hideContent?: boolean
}) => {
  const [textVisible, setTextVisibility] = useState(!hideContent)

  return (
    <InView onChange={() => setTextVisibility(true)} triggerOnce>
      {textVisible && children}
    </InView>
  )
}
